/* tslint:disable */
export var icon = "\n<svg width=\"21\" height=\"16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.527 8.527L7 5 6 6l4.5 4.485L15 6l-1-1-3.473 3.527z\" fill-rule=\"evenodd\"/></svg>\n";
//# sourceMappingURL=button-dd.svg.js.map